import template from './myConnectAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            controller() {
              const self = this;
              self.agentId = '';
              self.managerId = '';
              self.confirm = () => {
                $mdDialog.hide({ agentId: self.agentId, managerId: self.managerId });
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            multiple: true,
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
